export default {
    API_URL: process.env.VUE_APP_BASE_URL || "https://2276-49-249-56-118.ap.ngrok.io/api/v1",
    // API_URL: process.env.VUE_APP_BASE_URL || 'https://948b-49-249-56-118.ap.ngrok.io/api/v1',
    CRYPTO_KEY: '980@^56G-S!s76*$',
};
